import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as echarts from "echarts";
import wechatAuth from "./common/wechatAuth";
import { Circle, Toast, Loading, Popup, Tab, Tabs, Icon, Swipe, SwipeItem, DropdownMenu, DropdownItem, List, Image as VanImage, Area, Tabbar, TabbarItem, Progress, NoticeBar, Field, PullRefresh } from 'vant';
import 'vant/lib/index.css';
import VueClipBoard from 'vue-clipboard2';

// 全局方法挂载


// 视频播放器
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
Vue.use(VueDPlayer);

//查看大图
import preview from 'vue-photo-preview'
import "vue-photo-preview/dist/skin.css"
Vue.use(preview)


Vue.use(Circle);
Vue.use(Toast);
Vue.use(VueClipBoard);
Vue.use(Loading);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(List);
Vue.use(VanImage);
Vue.use(Area);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Progress);
Vue.use(NoticeBar);
Vue.use(Field);
Vue.use(PullRefresh);

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.config.ignoredElements = ["wx-open-launch-weapp"]
Vue.use(router)

Vue.use(wechatAuth, {
  appid: "wxcf7b485c3e496ea7",
  scope: "snsapi_userinfo"
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
